/**
 * Banana Santana Theme Animations
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    if (!window.theme.settings.animationsEnabled) return;

    // Scroll animations
    initScrollAnimations();
    
    // Parallax effects
    initParallaxEffects();
    
    // Hover animations
    initHoverAnimations();
  });

  function initScrollAnimations() {
    const elements = document.querySelectorAll('.scroll-fade-in, .scroll-slide-up, .scroll-slide-left, .scroll-slide-right, .scroll-scale-in');
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          
          // For stagger animations
          if (entry.target.classList.contains('stagger-children')) {
            const children = entry.target.children;
            Array.from(children).forEach(function(child, index) {
              setTimeout(function() {
                child.classList.add('in-view');
              }, index * 100);
            });
          }
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    elements.forEach(function(element) {
      observer.observe(element);
    });
  }

  function initParallaxEffects() {
    const parallaxElements = document.querySelectorAll('.parallax');
    
    if (parallaxElements.length === 0) return;
    
    window.addEventListener('scroll', function() {
      const scrolled = window.pageYOffset;
      
      parallaxElements.forEach(function(element) {
        const speed = element.dataset.speed || 0.5;
        const yPos = -(scrolled * speed);
        element.style.transform = 'translateY(' + yPos + 'px)';
      });
    });
  }

  function initHoverAnimations() {
    // Add hover classes dynamically
    const cards = document.querySelectorAll('.product-card, .glass-card');
    
    cards.forEach(function(card) {
      card.addEventListener('mouseenter', function() {
        this.classList.add('hovering');
      });
      
      card.addEventListener('mouseleave', function() {
        this.classList.remove('hovering');
      });
    });
  }

  // Floating orbs animation
  const orbs = document.querySelectorAll('.orb');
  orbs.forEach(function(orb, index) {
    orb.style.animationDelay = (index * 2) + 's';
  });

})();